import { AreaData, BarData, BaselineData, CandlestickData, HistogramData, ISeriesApi, LineData, LineType, Point, SeriesType, Time } from "lightweight-charts"
import { ChartType } from "../../proto/generated/chart"
import { SuperChartConfiguration_DateRange, SuperChartConfiguration_TimeBucket } from "../../proto/generated/superchart-page"
import { Security } from "../../proto/generated/security"
import { ChartPriceScaleOptions, PaneConfig, Series, SeriesGroup } from "../chartV2/chart.typings"

export type CrossHairInfoMultiStrikeChart = {
    point: Point
    time: number
    price: number
    seriesData: Map<ISeriesApi<SeriesType, Time>, LineData<Time>>
}

export type ChartConfigMultiStrikeChart = {
    timeBucket: SuperChartConfiguration_TimeBucket,
    selectedDateRange?: SuperChartConfiguration_DateRange,
    chartType: ChartType,
    comparableSecurities: Security[],
    panes: string[],
    showOiProfile: boolean,
    panesConfig: Record<string, PaneConfig>
    leftScaleGroup: string
    seriesGroups: Record<string, SeriesGroup>
    series: Record<string, Series>
    loading: boolean
    scaleOptions: ChartPriceScaleOptions
    replayMode: boolean
}

export type ChartSnapshotMultiStrikeChart = Map<string, LineData<Time>>

export type DataMultiStrikeChart = CandlestickData | AreaData | BarData | BaselineData | HistogramData | LineData 

export const PlotTypesMenuMultiStrikeChart = [
    {
        label: 'Line',
        type: LineType.Simple
    },
    {
        label: 'Curved line',
        type: LineType.Curved
    },
    {
        label: 'Step line',
        type: LineType.WithSteps
    },
    {
        label: 'Cross',
        type: LineType.Cross
    },
    {
        label: 'Circles',
        type: LineType.Circle
    }
]